import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=622f2bb0&"
import script from "./ApplicantDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports